import { useQuery, type UseQueryResult } from "@tanstack/react-query";
import { useAuth } from "@/auth/AuthContext";
import { createApiClient } from "@/api/client";
import { queryKeys } from "@/api/queryClient";
import type { UsageReport } from "@/types";

// Fleet-Uebersicht: juengster Usage-Report pro Deployment.
export function useFleet(): UseQueryResult<UsageReport[]> {
  const { session, logout } = useAuth();
  return useQuery({
    queryKey: queryKeys.list("fleet"),
    queryFn: () => {
      const client = createApiClient({
        getToken: () => session?.accessToken ?? null,
        onUnauthorized: logout,
      });
      return client.get<UsageReport[]>("/usage/fleet");
    },
    enabled: !!session,
  });
}
